import { Section } from 'src/card_history/types'
import { openRoute as openBaseRoute } from 'src/redux/actions/routes'
import { CatalogRoute, CatalogSubroute } from 'src/catalog/routes/CatalogRoute'
import {
  GiftStoreRoute,
  GiftStoreSubroute,
} from 'src/gift_store/routes/GiftStoreRoute'
import { OrdersRoute, OrdersSubroute } from 'src/orders/routes/OrdersRoute'
import { CampaignStoreRoute } from 'src/campaign_store/routes/CampaignStoreRoute'
import { RelationshipManagerRoute } from 'src/contacts/routes/RelationshipManagerRoute'
import { GroupsRoute } from 'src/contacts/routes/GroupsRoute'
import { CardRoute } from 'src/card/routes/CardRoute'
import {
  CampaignRoute,
  CampaignSubroute,
} from 'src/campaigns/routes/CampaignRoute'
import {
  CampaignsRoute,
  CampaignsSubroute,
} from 'src/campaigns/routes/CampaignsRoute'
import { PricingRoute } from 'src/marketing/plans/routes/PricingRoute'
import { DashboardRoute } from 'src/dashboard/routes/DashboardRoute'
import { AccountRoute } from 'src/dashboard/routes/AccountRoute'
import { NotificationsRoute } from 'src/dashboard/routes/NotificationsRoute'
import { DraftedOrdersRoute } from 'src/dashboard/routes/DraftedOrdersRoute'
import { DraftedCardsRoute } from 'src/dashboard/routes/DraftedCardsRoute'
import {
  CardHistoryRoute,
  CardHistorySubroute,
} from 'src/dashboard/routes/CardHistoryRoute'
import { ImportContactsRoute } from 'src/contacts/routes/ImportContactsRoute'
import { PaymentSettingsRoute } from 'src/dashboard/routes/PaymentSettingsRoute'
import { AwardsRoute } from 'src/dashboard/routes/AwardsRoute'
import { SearchFilter } from 'src/chrome/FilteredSearchBar/types'

import { BaseRoute, BaseSubroute } from '../../routes/BaseRoute'
import { CreateCampaignRoute } from 'src/campaigns/routes/CreateCampaignRoute'

const openRoute = (subroute: BaseSubroute) =>
  openBaseRoute(BaseRoute(subroute), {})

export const openCatalog = (subroute?: CatalogSubroute) =>
  openRoute(CatalogRoute(subroute))

export const openCard = (cardId: string) => openRoute(CardRoute(cardId))

export const openOrder = (orderId: string, subroute?: OrdersSubroute) =>
  openRoute(OrdersRoute(orderId, subroute))

export const openGiftStore = (
  giftStoreSubroute?: GiftStoreSubroute,
  highLevelCategory?: string,
) => openRoute(GiftStoreRoute(giftStoreSubroute, highLevelCategory))

export const openCampaignStore = (categoryId?: string) =>
  openRoute(CampaignsRoute(CampaignStoreRoute(categoryId)))

export const openRelationshipManager = (subroute?: GroupsRoute) =>
  openRoute(RelationshipManagerRoute(subroute))

export const openGroups = () => openRoute(GroupsRoute())

export const openContactsImporter = () => openRoute(ImportContactsRoute())

export const openCampaigns = (subroute?: CampaignsSubroute) =>
  openRoute(CampaignsRoute(subroute))

export const openCreateCampaign = () =>
  openRoute(CampaignsRoute(CreateCampaignRoute()))

export const openCampaign = (campaignId: string, subroute?: CampaignSubroute) =>
  openRoute(CampaignsRoute(CampaignRoute(campaignId, subroute)))

export const openPricing = () => openRoute(PricingRoute())

export const openAccount = () => openRoute(DashboardRoute(AccountRoute()))

export const openAwards = () => openRoute(DashboardRoute(AwardsRoute()))

export const openNotifications = () =>
  openRoute(DashboardRoute(NotificationsRoute()))

export const openDraftedOrders = () =>
  openRoute(DashboardRoute(DraftedOrdersRoute()))

export const openDraftedCards = () =>
  openRoute(DashboardRoute(DraftedCardsRoute()))

export const openCardHistory = (
  section?: Section,
  filters?: SearchFilter[],
  subroute?: CardHistorySubroute,
) => openRoute(DashboardRoute(CardHistoryRoute(section, filters, subroute)))

export const openPaymentSettings = () =>
  openRoute(DashboardRoute(PaymentSettingsRoute()))
